<template>
  <div>
    <OneColumnPageLayout>
      <OutSideTitleCard
        class="mb-5"
        :title="$t('User.DeletedUsers')"
        :info="$t('ManageAccounts.DeletedUserListInfo')"
      >
        <h5
          v-if="selectedGroups && selectedGroups.length > 0"
          style="margin-bottom: -15px;"
          class="text-secondary"
        />

        <template #padding-zero>
          <DeletedUserListContent :selected-groups="selectedGroups" />
        </template>
      </OutSideTitleCard>
    </OneColumnPageLayout>
  </div>
</template>

<script>
  import OutSideTitleCard from '@/components/parts/card/OutSideTitleCard'
  import { mapGetters } from 'vuex'
  import OneColumnPageLayout
    from '@/components/pages/layouts/OneColumnPageLayout'
  import DeletedUserListContent from '../content/DeletedUserListContent.vue'

  export default {
    components: {
      OneColumnPageLayout,
      OutSideTitleCard,
      DeletedUserListContent
    },
    data: () => ({
      selectedGroups: null
    }),
    computed: {
      ...mapGetters(['ui', 'login']),
      is_admin () {
        return Boolean(this.login.profile.is_admin)
      }
    },
    methods: {
      applySelectedGroups (data) {
        this.selectedGroups = data
      }
    }
  }
</script>
